import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
var _dec, _class, _SubjectiveFeedback;
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
/** @jsx jsx */
import { Component } from 'react';
import PropTypes from 'prop-types';
import { jsx } from '@instructure/emotion';
import { ScreenReaderContent } from '@instructure/ui-a11y-content';
import { IconCheckLine, IconXLine, IconNotGradedLine } from '@instructure/ui-icons';
import { Text } from '@instructure/ui-text';
import t from '@instructure/quiz-i18n/es/format-message';
import generateComponentTheme from './theme';
import generateStyle from './styles';
import { withStyleOverrides } from '@instructure/quiz-common';
export var SubjectiveFeedback = (_dec = withStyleOverrides(generateStyle, generateComponentTheme), _dec(_class = (_SubjectiveFeedback = /*#__PURE__*/function (_Component) {
  function SubjectiveFeedback() {
    _classCallCheck(this, SubjectiveFeedback);
    return _callSuper(this, SubjectiveFeedback, arguments);
  }
  _inherits(SubjectiveFeedback, _Component);
  return _createClass(SubjectiveFeedback, [{
    key: "renderGradeIcon",
    value: function renderGradeIcon() {
      switch (this.props.gradeStatus) {
        case 'waiting':
          return jsx(IconNotGradedLine, null);
        case 'graded':
          // TODO: replace with "graded" icon once it exists
          return jsx(IconCheckLine, null);
        case 'correct':
          return jsx(IconCheckLine, null);
        case 'incorrect':
          return jsx(IconXLine, null);
        default:
          return jsx(IconNotGradedLine, null);
      }
    }
  }, {
    key: "getGradeText",
    value: function getGradeText() {
      switch (this.props.gradeStatus) {
        case 'waiting':
          return t('Waiting for grade');
        case 'graded':
          return t('Graded');
        case 'correct':
          return t('Correct');
        case 'incorrect':
          return t('Incorrect');
        default:
          // includes 'unknown'
          return '';
      }
    }
  }, {
    key: "render",
    value: function render() {
      return jsx("div", {
        className: "fs-mask"
      }, jsx("div", {
        css: this.props.styles.content
      }, jsx("div", {
        css: this.props.styles.iconHolder
      }, this.renderGradeIcon()), jsx(ScreenReaderContent, null, this.getGradeText()), this.props.children), jsx("div", {
        css: this.props.styles.gradeTextHolder
      }, jsx(Text, {
        color: "primary",
        size: "small"
      }, this.getGradeText())));
    }
  }]);
}(Component), _defineProperty(_SubjectiveFeedback, "displayName", 'SubjectiveFeedback'), _defineProperty(_SubjectiveFeedback, "componentId", "Quizzes".concat(_SubjectiveFeedback.displayName)), _defineProperty(_SubjectiveFeedback, "propTypes", {
  children: PropTypes.node,
  gradeStatus: PropTypes.oneOf(['waiting', 'graded', 'correct', 'incorrect', 'unknown']),
  /* eslint-disable react/forbid-prop-types, react/require-default-props */
  styles: PropTypes.object
}), _defineProperty(_SubjectiveFeedback, "defaultProps", {
  children: void 0,
  gradeStatus: 'unknown'
}), _SubjectiveFeedback)) || _class);
export default SubjectiveFeedback;